import { LowerCasePipe } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { OnyxPluralTranslatePipe } from '@onyx/angular';
import { DictionaryCode } from '../../../../../../common/enums/dictionary-code';
import { PaymentTermType } from '../../enums/payment-term-type';
import type { Contractor } from '../../interfaces/contractor';

@Component({
  selector: 'app-contractor-payment-term',
  imports: [OnyxPluralTranslatePipe, TranslatePipe, LowerCasePipe],
  templateUrl: './contractor-payment-term.component.html',
  styleUrl: './contractor-payment-term.component.scss',
})
export class ContractorPaymentTermComponent {
  public readonly payment = input.required<Contractor['payment']>();

  protected readonly DictionaryCode = DictionaryCode;
  protected readonly PaymentTermType = PaymentTermType;

  protected isDayOfWeek = computed(() =>
    [
      PaymentTermType.MONDAY,
      PaymentTermType.TUESDAY,
      PaymentTermType.WEDNESDAY,
      PaymentTermType.THURSDAY,
      PaymentTermType.FRIDAY,
      PaymentTermType.SATURDAY,
      PaymentTermType.SUNDAY,
    ].includes(this.payment().termType),
  );
}
